<template>
    <div class="card mb-3">
        <div class="card-body">
            <form v-on:submit.prevent="submit">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>عنوان طرح</label>
                            <input class="form-control" v-model="title">
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>قیمت</label>
                            <input class="form-control ltr-input" v-model="price" @keyup="numberFormat">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label>تصویر طرح</label>
                        <div class="form-group">
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="file"
                                    placeholder="انتخاب کنید" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کردن <input type="file" style="display: none" @change="setFileData"
                                            accept="image/jpeg,image/png">
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label>دسته بندی ها</label>
                        <Vselect v-model="categoriesId" :reduce="item => item.categoryId" label="title" multiple
                            :options="categories">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>

                    <div class="col-md-4 mt-2 mb-4">

                        <label> نوع کارت </label>
                        <div class="row">
                            <div class="col-4">
                                <label class="rdiobox"><input @change="changeCardType(0)" v-model="cardType"
                                        name="customer-type" value="0" checked type="radio"><span> گیفت کارت </span></label>
                            </div>
                            <div class="col-4">
                                <label class="rdiobox"><input @change="changeCardType(1)" v-model="cardType"
                                        name="customer-type" value="1" type="radio"><span> بن کارت </span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success">ذخیره اطلاعات</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Create',
    data() {
        return {
            showLoading: false,
            title: '',
            price: '',
            image: '',
            inventory: 0,
            categories: [],
            categoriesId: [],
            cardType: 0
        }
    },
    methods: {
        getData() {
            console.log(this.cardType);
            this.$api.get('Cards/Categories').then(({ data }) => {
                this.categories = data.result;
            });
        },
        numberFormat() {
            let value = this.price.toString().replace(/,/g, '');
            value = new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(value);
            if (value == 'NaN')
                value = '';
            this.price = value;
        },
        async toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFileData(e) {
            const file = e.target.files[0];
            if (file.size > 1000000) {
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم عکس نمی تواند بیشتر از 1 مگابایت باشد'
                });
                document.getElementById('file').setAttribute('placeholder', 'انتخاب کنید');
                this.image = '';
            } else {
                const finalFile = await this.toBase64(file);
                this.image = finalFile;
                document.getElementById('file').setAttribute('placeholder', file.name);
            }
        },
        changeCardType(val) {
            this.cardType = val
        },
        submit() {
             this.showLoading = true;
            const postedData = {
                title: this.title,
                price: parseInt(this.price.toString().replace(/,/g, '')),
                image: this.image,
                mainImage: this.image,
                inventory: this.inventory,
                categoriesId: this.categoriesId,
                type: this.cardType,
            }
            this.$api.post('Themes/Insert', postedData).then(({ data }) => {
                 if (data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'طرح جدید با موفقیت در سیستم ذخیره شد',
                    }).then(() => {
                        this.$router.push('/themes')
                    })
            }).catch(({ response }) => {
                let html = '';
                response.data.errors.map(err => html += err.message + '<br>');
                this.$swal({
                    icon: 'error',
                    title: 'خطا !',
                    html
                });
            }).finally(() => {
                this.showLoading = false;
            })
        }
    },
    created() {
        this.getData();
    },
}
</script>